/**
 * @module Core
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

import { HttpHeaders } from '@angular/common/http';
import { CommonHeadersBuilder } from '@core/api/utils/common-headers-builder';
import { StateStoreUtilsService } from '@support/state-object-hash-utilities/utils/state-store-utils.service';
import { CommonUtilService } from '@support/shared/services/common-util.service';
import { SETTINGS } from '@environment/settings';

export class RapHeadersBuilder extends CommonHeadersBuilder {
  /**
   * constructor
   * @param {Headers} headersInput
   * @param {StateStoreUtilsService} stateStoreUtils
   * @param {CommonUtilService} commonUtil
   */
  constructor(
    headersInput: HttpHeaders = null,
    protected stateStore: StateStoreUtilsService,
    protected commonUtil: CommonUtilService
  ) {
    super(stateStore, commonUtil);
    this.headers = super.addCommonHeaders(headersInput);
    this.addChannel();
    this.addApplicationUserId();
    this.addActivityId();
    this.addStackId();

    if (this.getTokenId()) {
      this.addInteractionId();
      this.addAuthorization();
      this.addSessionId();
      this.addWorkflowId();
      this.addScreenId();
      this.addDealerCode();
    }
  }

  /**
   * Method to add the channel to header
   */
  public addChannel(): void {
    this.headers = this.headers.append('channelId', 'NRD');
  }

  /**
   * method to add authorization token to header
   */
  public addAuthorization(): void {
    this.headers = this.headers.append(
      'Authorization',
      this.stateStoreUtils.getAuthToken() ? this.stateStoreUtils.getAuthToken() : ''
    );
  }

  /**
   * method to add applicationUserId header
   */

  public addApplicationUserId(): void {
    if (this.stateStoreUtils.getApplicationUserId()) {
      this.headers = this.headers.append('applicationUserId', this.stateStoreUtils.getApplicationUserId());
    }
  }

  /**
   * method to add stackId for B/G Deployments. Picks what "stack" to use Blue stack or green stack.
   */
  public addStackId(): void {
    this.headers = this.headers.append('stackId', SETTINGS.STACKID);
  }

  /**
   * method to add Dealer Code header
   */
  public addDealerCode(): void {
    this.headers = this.headers.append('dealerCode', this.stateStoreUtils.getDealerCode() || '');
  }
}
